import {
  CAREER_MOTIVATION_ID_CONSIDERING_CAREER,
  CAREER_MOTIVATION_ID_CURRENTLY_JOB_HUNTING,
  CAREER_MOTIVATION_ID_NO_IDEA,
  CAREER_MOTIVATION_ID_WANT_TO_HEAR,
  CAREER_MOTIVATION_ID_WITHIN_SIX_MONTHS,
  CAREER_MOTIVATION_ID_WITHIN_THREE_MONTHS,
} from '@findy-code/yuffie/models';
import { ButtonV2 } from '@findy-code/yuffie/ui/button';
import { ButtonLikeRadio } from '@findy-code/yuffie/ui/button-like-radio';
import { ButtonLikeRadioGroup } from '@findy-code/yuffie/ui/button-like-radio-group';
import { TextModal } from '@findy-code/yuffie/ui/modal';

import type { BaseModalProps, FormData } from '../types';
import { useCareerMotivationModalPresenter } from './career-motivation-modal.presenter';

type Props = BaseModalProps & {
  onUpdateCareerMotivation?: (values: FormData) => void;
  onAfterUpdateCareerMotivation?: (values: FormData) => void;
  values?: FormData;
};

export const CareerMotivationModalComponent = ({
  isOpen,
  onClose,
  onUpdateCareerMotivation,
  onAfterUpdateCareerMotivation,
  values,
}: Props) => {
  const { register, handleSubmit, isSubmittable } =
    useCareerMotivationModalPresenter({ values });

  const handleSubmitForm = handleSubmit(async (values) => {
    await onUpdateCareerMotivation?.(values);
    await onAfterUpdateCareerMotivation?.(values);
    onClose?.();
  });

  return (
    <TextModal
      body={
        <form id="career-motivation-modal-form" onSubmit={handleSubmitForm}>
          <p style={{ marginBottom: 'var(--fds-spacing-m, 16px)' }}>
            転職意欲を変更いただくと、意欲に合わせたサポートをさせていただきます。
          </p>
          <fieldset aria-label="転職意欲">
            <ButtonLikeRadioGroup>
              <ButtonLikeRadio
                {...register('careerMotivation', {
                  required: true,
                })}
                value={CAREER_MOTIVATION_ID_CURRENTLY_JOB_HUNTING}
              >
                転職活動中
              </ButtonLikeRadio>
              <ButtonLikeRadio
                {...register('careerMotivation', {
                  required: true,
                })}
                value={CAREER_MOTIVATION_ID_WITHIN_THREE_MONTHS}
              >
                3ヶ月以内に転職したい
              </ButtonLikeRadio>
              <ButtonLikeRadio
                {...register('careerMotivation', {
                  required: true,
                })}
                value={CAREER_MOTIVATION_ID_WITHIN_SIX_MONTHS}
              >
                半年以内に転職したい
              </ButtonLikeRadio>
              <ButtonLikeRadio
                {...register('careerMotivation', {
                  required: true,
                })}
                value={CAREER_MOTIVATION_ID_WANT_TO_HEAR}
              >
                {process.env
                  .NEXT_PUBLIC_FEATURE_ADD_CAREER_MOTIVATION_STATUS === 'true'
                  ? 'よい求人があれば検討したい'
                  : '話だけでも聞いてみたい'}
              </ButtonLikeRadio>
              {process.env.NEXT_PUBLIC_FEATURE_ADD_CAREER_MOTIVATION_STATUS ===
                'true' && (
                <ButtonLikeRadio
                  {...register('careerMotivation', {
                    required: true,
                  })}
                  value={CAREER_MOTIVATION_ID_CONSIDERING_CAREER}
                >
                  キャリアについて考え始めている
                </ButtonLikeRadio>
              )}
              <ButtonLikeRadio
                {...register('careerMotivation', {
                  required: true,
                })}
                value={CAREER_MOTIVATION_ID_NO_IDEA}
              >
                すぐの転職は考えていない
              </ButtonLikeRadio>
            </ButtonLikeRadioGroup>
          </fieldset>
        </form>
      }
      foot={
        <ButtonV2
          disabled={!isSubmittable}
          form="career-motivation-modal-form"
          size="l"
          type="submit"
          variant="primary"
        >
          転職意欲を保存
        </ButtonV2>
      }
      isOpen={isOpen}
      title="現在の転職意欲を教えてください"
      onRequestClose={onClose}
    />
  );
};
